import * as React from 'react';
import { SVGProps } from 'react';

const SvgNoPatient = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 18c.22-.72 3.31-2 6-2 0-.7.13-1.37.35-1.99C8.62 13.91 3 15.27 3 18v2h9.54c-.52-.58-.93-1.25-1.19-2H5zm12-4.75a2.75 2.75 0 0 0-2.402 4.091l3.742-3.742a2.738 2.738 0 0 0-1.341-.348zm2.401 1.409-3.742 3.742a2.75 2.75 0 0 0 3.743-3.743zM12.75 16a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0z" />
  </svg>
);

export default SvgNoPatient;
